import Icon from './Icon';
import LeadForm from './LeadForm';
import { CONSULTATION_POINTS } from '../constants/content';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function Consultation() {
  return (
    <section className="section section--mint" id="consultation">
      <div className="shell">
        <header className="section__head section__head--left">
          <p className="kicker">Free check</p>
          <h2>Get your free, no-obligation error check</h2>
          <p className="section__lede">
            Tell us what went wrong. We will explain the cause and the cost to fix it —
            before you spend a cent.
          </p>
        </header>

        <div className="consult">
          <div className="consult__copy">
            <figure className="consult__photo">
              <img
                src="/images/consult-desk.webp"
                alt="Laptop open on an accountant desk with notebook and calculator"
                width="1280"
                height="720"
                loading="lazy"
                decoding="async"
              />
            </figure>

            <h3>Every free check includes</h3>
            <ul className="ticks">
              {CONSULTATION_POINTS.map((point) => (
                <li key={point}>
                  <Icon name="check" size={16} />
                  {point}
                </li>
              ))}
            </ul>

            <div className="consult__cta-row">
              <a href={SUPPORT_PHONE_TEL} className="consult__contact">
                <Icon name="phone" size={22} />
                <span>
                  <small>Experts available 24/7</small>
                  {SUPPORT_PHONE_LABEL}
                </span>
              </a>
              <button type="button" className="consult__contact" onClick={openZohoChat}>
                <Icon name="chat" size={22} />
                <span>
                  <small>Prefer to type?</small>
                  Start live chat
                </span>
              </button>
            </div>
          </div>

          <div className="consult__form">
            <LeadForm
              variant="full"
              title="Request your free check"
              subtitle="A certified expert replies the same working day."
              cta="Send my request"
              formName="consultation"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
